module.exports = __webpack_public_path__ + "images/news_image-8eaaadefbf85615ab68ac33a725dae42.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/news_image.jpg
// module id = 52
// module chunks = 0